'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _FactboxFooter = require('./FactboxFooter');

var _FactboxFooter2 = _interopRequireDefault(_FactboxFooter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _FactboxFooter2.default;
//# sourceMappingURL=index.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/@spp/hyperion-web-components/~/@spp/ui-factbox/lib/cjs/FactboxFooter/index.js
 ** module id = 513
 ** module chunks = 1
 **/